import { Decimal } from 'decimal.js';
import { poolDetailsMap, poolDetailsMapByPoolName } from '../common/maps.js';
import { Blockchain } from './blockchain.js';
import { getConf } from '../common/constants.js';
import { stSuiExchangeRate, getConf as getStSuiConf } from '@alphafi/stsui-sdk';
export class Protocol {
    suiClient;
    blockchain;
    constructor(suiClient, network) {
        this.suiClient = suiClient;
        this.blockchain = new Blockchain(network);
    }
    async getAprMap() {
        const apiUrl = 'https://api.alphafi.xyz/apr';
        const response = await fetch(`${apiUrl}`);
        const dataArr = (await response.json());
        const aprMap = new Map();
        for (const data of dataArr) {
            const poolId = poolDetailsMapByPoolName[data.name].poolId;
            if (!poolId) {
                console.error(`Pool ${data.name} not found in poolDetailsMap`);
                continue;
            }
            const entries = Object.entries(data.apr);
            const parentApr = entries.find(([key]) => key !== 'alphaApr')?.[1];
            aprMap.set(poolId, {
                parentApr: new Decimal(parentApr ?? 0),
                alphaMiningApr: new Decimal(data.apr.alphaApr),
            });
        }
        return aprMap;
    }
    async getPriceMap() {
        const apiUrl = 'https://api.alphalend.xyz/public/graphql';
        const query = `
      query {
        coinInfo {
          coinType
          coingeckoPrice
        }
      }
    `;
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query }),
        });
        const dataArr = (await response.json()).data.coinInfo;
        const priceMap = new Map();
        for (const data of dataArr) {
            priceMap.set(data.coinType, new Decimal(data.coingeckoPrice));
        }
        priceMap.set('0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI', priceMap.get('0x2::sui::SUI') || new Decimal(0));
        return priceMap;
    }
    async getNaviTvlMap() {
        const naviUrl = 'https://api.alphafi.xyz/navi-params';
        const response = await fetch(naviUrl);
        const dataArr = await response.json();
        const naviTvlMap = new Map();
        for (const data of dataArr) {
            if (!poolDetailsMapByPoolName[data.poolName])
                continue;
            const poolId = poolDetailsMapByPoolName[data.poolName].poolId;
            if (!poolId) {
                console.error(`Pool ${data.poolName} not found in poolDetailsMap`);
                continue;
            }
            naviTvlMap.set(poolId, new Decimal(data.naviPoolTVL));
        }
        return naviTvlMap;
    }
    async getNaviLoopingPoolDebt() {
        const debtMap = new Map();
        const poolKeys = Object.keys(poolDetailsMap);
        for (const poolKey of poolKeys) {
            if (poolDetailsMap[poolKey].strategyType === 'SINGLE-ASSET-LOOPING') {
                const debt = await this.getSingularNaviLoopingPoolDebt(poolKey);
                debtMap.set(poolKey, debt);
            }
        }
        return debtMap;
    }
    async getVoloExchangeRate() {
        const apiUrl = 'https://open-api.naviprotocol.io/api/volo/stats';
        try {
            const response = await fetch(apiUrl);
            const data = (await response.json());
            return new Decimal(data.data.exchangeRate);
        }
        catch (error) {
            console.log('error in api', error);
            return new Decimal(0);
        }
    }
    async getStsuiExchangeRate() {
        const suiTostSuiExchangeRate = await stSuiExchangeRate(getStSuiConf().LST_INFO, true);
        return new Decimal(suiTostSuiExchangeRate);
    }
    async getSingularNaviLoopingPoolDebt(poolId) {
        const debt = ((await this.suiClient.getDynamicFieldObject({
            parentId: poolDetailsMap[poolId].investorId,
            name: {
                type: 'vector<u8>',
                value: 'debt'.split('').map((char) => char.charCodeAt(0)),
            },
        })).data?.content).fields.value.toString();
        return debt;
    }
    async getBucketTVL() {
        try {
            const fountain = (await this.suiClient.getObject({
                id: getConf().FOUNTAIN,
                options: { showContent: true },
            })).data;
            const flask = (await this.suiClient.getObject({
                id: getConf().FLASK,
                options: { showContent: true },
            })).data;
            const totalSbuckInFountain = fountain.content.fields.staked;
            const buckPerSbuck = new Decimal(flask.content.fields.reserves).div(flask.content.fields.sbuck_supply.fields.value);
            const totalBuckInFountain = new Decimal(totalSbuckInFountain).mul(buckPerSbuck);
            return totalBuckInFountain.div(new Decimal(1e9));
        }
        catch {
            throw new Error('error in bucket protocol tvl');
        }
    }
}
//# sourceMappingURL=protocol.js.map